import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowMerge = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 15,
	fill: "none",
	viewBox: "0 0 16 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "m.5 1.9 5.6 5.6-5.6 5.6 1.4 1.4 6-6h7.6v-2H7.9l-6-6L.5 1.9Z"
	})
});
export default SvgIconArrowMerge;
